<template>
  <div id="dashboard-onsite" v-if="onsite.data != null" v-loading="onsite.loading">
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.onsite.checkin") }}</h3>

            <div class="input-container">
              <el-select v-model="onsiteFilter.checkInTagId" @change="onsiteTagIdChanged" @clear="onsiteFilter.checkInTagId = null" :placeholder="$t('components.dashboard.onsite.placeholderAll')" size="medium" clearable>
                <el-option v-for="item in tags" :key="item.id" :label="item.title" :value="item.id">
                  <i class="fas fa-circle mr-2" :style="{ color: item.color }"></i>
                  <span>{{ item.title }}</span>
                </el-option>
              </el-select>
            </div>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
            </el-tooltip>
          </div>

          <el-table :data="onsite.data.checkInStatistics" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column label="Günler" min-width="180">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.title }}</b>
                </span>
              </template>
            </el-table-column>

            <template v-if="onsite.data.checkInStatistics.length > 0">
              <el-table-column v-for="(item, index) in onsite.data.checkInStatistics[0].statistics" :key="index" :label="item.title" width="150">
                <template slot-scope="scope">
                  <span>
                    <b>{{ onsite.data.checkInStatistics[scope.$index].statistics[index].count }}</b>
                    {{ $t("components.dashboard.onsite.total") }}
                  </span>
                  <span>
                    <b>{{ onsite.data.checkInStatistics[scope.$index].statistics[index].countUnique }}</b>
                    {{ $t("components.dashboard.onsite.unique") }}
                  </span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <!-- <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.onsite.automaticCheckin") }}</h3>

            <div class="input-container">
              <el-button-group>
                <el-button size="small" v-for="(item, index) in getEnums.find(x => x.title == 'CheckInType').enums.filter(y => y.key != 2)" :key="index" :type="onsiteFilter.automaticCheckInType == item.key ? 'primary' : ''" @click="automaticCheckInTypeChanged(item.key)">{{ item.displayName }}</el-button>
              </el-button-group>
              <el-select v-model="onsiteFilter.automaticCheckInTagId" @change="automaticCheckInTagIdChanged" @clear="onsiteFilter.automaticCheckInTagId = null" :placeholder="$t('components.dashboard.onsite.placeholderAll')" size="medium" clearable>
                <el-option v-for="item in tags" :key="item.id" :label="item.title" :value="item.id">
                  <i class="fas fa-circle mr-2" :style="{ color: item.color }"></i>
                  <span>{{ item.title }}</span>
                </el-option>
              </el-select>
            </div>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
            </el-tooltip>
          </div>

          <div  :class="!eventPermissions.advancedReportsAndMetrics ? 'pie-chart-container' : ''">
            <upgrade-overlay position="absolute" lottieWidth="150px" v-if="!eventPermissions.advancedReportsAndMetrics" size="small"></upgrade-overlay>
            <el-table :data="onsite.data.automaticCheckInStatistics" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column label="Kontrolcü" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.title }}</b>
                  </span>
                </template>
              </el-table-column>

              <template v-if="onsite.data.automaticCheckInStatistics.length > 0">
                <el-table-column v-for="(item, index) in onsite.data.automaticCheckInStatistics[0].statistics" :key="index" :fixed="index == onsite.data.automaticCheckInStatistics[0].statistics.length - 1 ? 'right' : false" :label="item.title" width="150">
                  <template slot-scope="scope">
                    <span>
                      <b>{{ onsite.data.automaticCheckInStatistics[scope.$index].statistics[index].count }}</b>
                      {{ $t("components.dashboard.onsite.total") }}
                    </span>
                    <span>
                      <b>{{ onsite.data.automaticCheckInStatistics[scope.$index].statistics[index].countUnique }}</b>
                      {{ $t("components.dashboard.onsite.unique") }}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row> -->

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.onsite.standCheckin") }}</h3>

            <div class="input-container">
              <el-select v-model="onsiteFilter.standCheckInTagId" @change="standCheckInTagIdChanged" @clear="onsiteFilter.standCheckInTagId = null" :placeholder="$t('components.dashboard.onsite.placeholderAll')" size="medium" clearable>
                <el-option v-for="item in tags" :key="item.id" :label="item.title" :value="item.id">
                  <i class="fas fa-circle mr-2" :style="{ color: item.color }"></i>
                  <span>{{ item.title }}</span>
                </el-option>
              </el-select>
            </div>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
            </el-tooltip>
          </div>
          <div :class="false ? 'pie-chart-container' : ''">
            <upgrade-overlay position="absolute" lottieWidth="150px" size="small" v-if="false"></upgrade-overlay>
            <el-table :data="onsite.data.standStatistics" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column label="Kontrolcü" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.title }}</b>
                  </span>
                </template>
              </el-table-column>

              <template v-if="onsite.data.standStatistics.length > 0">
                <el-table-column v-for="(item, index) in onsite.data.standStatistics[0].statistics" :key="index" :fixed="index == onsite.data.standStatistics[0].statistics.length - 1 ? 'right' : false" :label="item.title" width="170">
                  <template slot-scope="scope">
                    <span>
                      <b>{{ onsite.data.standStatistics[scope.$index].statistics[index].count }}</b>
                      {{ $t("components.dashboard.onsite.total") }}
                    </span>
                    <span>
                      <b>{{ onsite.data.standStatistics[scope.$index].statistics[index].countUnique }}</b>
                      {{ $t("components.dashboard.onsite.unique") }}
                    </span>
                    <el-button size="mini" v-if="index == onsite.data.standStatistics[0].statistics.length - 1" icon="fas fa-download" @click="exportStandCheckIn(scope.row.id)" circle></el-button>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.onsite.accessControl") }}</h3>

            <div class="input-container">
              <el-select v-model="onsiteFilter.accessLogTagId" @change="accessLogTagIdChanged" @clear="onsiteFilter.accessLogTagId = null" :placeholder="$t('components.dashboard.onsite.placeholderAll')" size="medium" clearable>
                <el-option v-for="item in tags" :key="item.id" :label="item.title" :value="item.id">
                  <i class="fas fa-circle mr-2" :style="{ color: item.color }"></i>
                  <span>{{ item.title }}</span>
                </el-option>
              </el-select>
            </div>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
            </el-tooltip>
          </div>

          <el-table :data="onsite.data.accessLogStatistics" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column label="Kontrolcü" min-width="180">
              <template slot-scope="scope">
                <span>
                  <b>{{ scope.row.title }}</b>
                </span>
              </template>
            </el-table-column>

            <template v-if="onsite.data.accessLogStatistics.length > 0">
              <el-table-column v-for="(item, index) in onsite.data.accessLogStatistics[0].statistics" :key="index" :fixed="index == onsite.data.accessLogStatistics[0].statistics.length - 1 ? 'right' : false" :label="item.title" width="150">
                <template slot-scope="scope">
                  <span>
                    <b>{{ onsite.data.accessLogStatistics[scope.$index].statistics[index].count }}</b>
                    {{ $t("components.dashboard.onsite.total") }}
                  </span>
                  <span>
                    <b>{{ onsite.data.accessLogStatistics[scope.$index].statistics[index].countUnique }}</b>
                    {{ $t("components.dashboard.onsite.unique") }}
                  </span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.onsite.cardPrinting") }}</h3>

            <div class="input-container">
              <el-select v-model="onsiteFilter.cardPrintTagId" @change="cardPrintTagIdChanged" @clear="onsiteFilter.cardPrintTagId = null" :placeholder="$t('components.dashboard.onsite.placeholderAll')" size="medium" clearable>
                <el-option v-for="item in tags" :key="item.id" :label="item.title" :value="item.id">
                  <i class="fas fa-circle mr-2" :style="{ color: item.color }"></i>
                  <span>{{ item.title }}</span>
                </el-option>
              </el-select>
            </div>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
            </el-tooltip>
          </div>
          <div :class="false ? 'pie-chart-container' : ''">
            <upgrade-overlay position="absolute" lottieWidth="150px" size="small" v-if="false"></upgrade-overlay>
            <el-table :data="onsite.data.cardPrintStatistics" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column label="Taslak" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.title }}</b>
                  </span>
                </template>
              </el-table-column>

              <template v-if="onsite.data.cardPrintStatistics.length > 0">
                <el-table-column v-for="(item, index) in onsite.data.cardPrintStatistics[0].statistics" :key="index" :fixed="index == onsite.data.cardPrintStatistics[0].statistics.length - 1 ? 'right' : false" :label="item.title" width="150">
                  <template slot-scope="scope">
                    <span>
                      <b>{{ onsite.data.cardPrintStatistics[scope.$index].statistics[index].count }}</b>
                      {{ $t("components.dashboard.onsite.total") }}
                    </span>
                    <span>
                      <b>{{ onsite.data.cardPrintStatistics[scope.$index].statistics[index].countUnique }}</b>
                      {{ $t("components.dashboard.onsite.unique") }}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="statistics-container">
          <div class="overview-table-header">
            <h3>{{ $t("components.dashboard.onsite.promotionalDistribution") }}</h3>

            <div class="input-container">
              <el-select v-model="onsiteFilter.promotionReceiveTagId" @change="promotionReceiveTagIdChanged" @clear="onsiteFilter.promotionReceiveTagId = null" :placeholder="$t('components.dashboard.onsite.placeholderAll')" size="medium" clearable>
                <el-option v-for="item in tags" :key="item.id" :label="item.title" :value="item.id">
                  <i class="fas fa-circle mr-2" :style="{ color: item.color }"></i>
                  <span>{{ item.title }}</span>
                </el-option>
              </el-select>
            </div>
            <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
              <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
            </el-tooltip>
          </div>
          <div :class="true ? 'pie-chart-container' : ''">
            <upgrade-overlay position="absolute" lottieWidth="150px" size="small" v-if="false"></upgrade-overlay>
            <el-table :data="onsite.data.promotionReceiveStatistics" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column label="Promosyon" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.title }}</b>
                  </span>
                </template>
              </el-table-column>

              <template v-if="onsite.data.promotionReceiveStatistics.length > 0">
                <el-table-column v-for="(item, index) in onsite.data.promotionReceiveStatistics[0].statistics" :key="index" :fixed="index == onsite.data.promotionReceiveStatistics[0].statistics.length - 1 ? 'right' : false" :label="item.title" width="150">
                  <template slot-scope="scope">
                    <span>
                      <b>{{ onsite.data.promotionReceiveStatistics[scope.$index].statistics[index].count }}</b>
                      {{ $t("components.dashboard.onsite.total") }}
                    </span>
                    <span>
                      <b>{{ onsite.data.promotionReceiveStatistics[scope.$index].statistics[index].countUnique }}</b>
                      {{ $t("components.dashboard.onsite.unique") }}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {},
  name: "Onsite",
  data() {
    return {};
  },
  methods: {
    exportStandCheckIn(id) {
      this.exportXlsx(10, id, null);
    },
    async onsiteTagIdChanged() {
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async automaticCheckInTagIdChanged() {
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async automaticCheckInTypeChanged(key) {
      (await this.onsiteFilter.automaticCheckInType) == key ? (this.onsiteFilter.automaticCheckInType = null) : (this.onsiteFilter.automaticCheckInType = key);
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async accessLogTagIdChanged() {
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async accessLogCheckInTypeChanged(key) {
      (await this.onsiteFilter.accessLogType) == key ? (this.onsiteFilter.accessLogType = null) : (this.onsiteFilter.accessLogType = key);
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async cardPrintTagIdChanged() {
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async promotionReceiveTagIdChanged() {
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async standCheckInTagIdChanged() {
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    async standCheckInTypeChanged(key) {
      (await this.onsiteFilter.standCheckInType) == key ? (this.onsiteFilter.standCheckInType = null) : (this.onsiteFilter.standCheckInType = key);
      await this.$store.dispatch("getOnsite", this.onsiteFilter);
      this.onsiteFilter.forceRefresh = false;
    },

    downloadReport() {
      axios.post("report/generalstatistics", {}).then(res => {
        this.$message.success(res.data.alert.message);
      });
    }
  },
  async mounted() {
    await this.$store.dispatch("getTags");

    if (this.onsite.data == null) {
      await this.$store.dispatch("getOnsite", {});
    }
  },

  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    onsite() {
      var onsiteDummy = JSON.parse(JSON.stringify(this.$store.getters.getDashboardOnsite));
      if (onsiteDummy.data != null) {
        if (false) {
          onsiteDummy.data.automaticCheckInStatistics = onsiteDummy.data.automaticCheckInStatistics.slice(0, 5);
          onsiteDummy.data.automaticCheckInStatistics.map(x => {
            x.statistics = x.statistics.map(y => {
              y.count = 0;
              y.countUnique = 0;
              return y;
            });
            return x;
          });
          onsiteDummy.data.standStatistics = onsiteDummy.data.standStatistics.slice(0, 5);
          onsiteDummy.data.standStatistics.map(x => {
            x.statistics = x.statistics.map(y => {
              y.count = 0;
              y.countUnique = 0;
              return y;
            });
            return x;
          });
          onsiteDummy.data.cardPrintStatistics = onsiteDummy.data.cardPrintStatistics.slice(0, 5);
          onsiteDummy.data.cardPrintStatistics.map(x => {
            x.statistics = x.statistics.map(y => {
              y.count = 0;
              y.countUnique = 0;
              return y;
            });
            return x;
          });
          onsiteDummy.data.promotionReceiveStatistics = onsiteDummy.data.promotionReceiveStatistics.slice(0, 5);
          onsiteDummy.data.promotionReceiveStatistics.map(x => {
            x.statistics = x.statistics.map(y => {
              y.count = 0;
              y.countUnique = 0;
              return y;
            });
            return x;
          });
        }
      }

      return onsiteDummy;
    },
    onsiteFilter() {
      return this.$store.getters.getOnsiteFilter;
    },
    tags() {
      return this.$store.getters.getTagsList;
    }
  },

  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Onsite.vue